import { useDecision } from '@optimizely/react-sdk';

import type { FeatureFlagName } from './flags';

type FeatureFlagResult = {
  enabled: boolean;
  variables: Record<string, unknown>;
};

type LocalOverride = {
  enabled?: boolean;
  variables?: Record<string, unknown>;
};

const overrides: Partial<Record<FeatureFlagName, LocalOverride>> = {
  // edit me locally
};

/** Dev-only override map. Edit `overrides` above for local QA; reset to `{}` before committing. */
const LOCAL_OVERRIDES: Partial<Record<FeatureFlagName, LocalOverride>> =
  process.env.NODE_ENV === 'development' ? overrides : {};

export function useFeatureFlag(key: FeatureFlagName): FeatureFlagResult {
  const [decision] = useDecision(key);
  const sdkVariables = (decision.variables ?? {}) as Record<string, unknown>;
  const override = LOCAL_OVERRIDES[key];

  if (!override) {
    return { enabled: decision.enabled, variables: sdkVariables };
  }

  return {
    enabled: override.enabled ?? decision.enabled,
    variables: { ...sdkVariables, ...(override.variables ?? {}) },
  };
}
